import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { ProductsProvider } from './context/products_context'
import { FilterProvider } from './context/filter_context'
import { CartProvider } from './context/cart_context'
import { UserProvider } from './context/user_context'
import { FirebaseAuthProvider } from "./firebase/AuthContext";

//import { Auth0Provider } from '@auth0/auth0-react'

ReactDOM.render(
	<FirebaseAuthProvider>
		<UserProvider>
			<ProductsProvider>
				<FilterProvider>
					<CartProvider>
						<App />
					</CartProvider>
				</FilterProvider>
			</ProductsProvider>
		</UserProvider>
	</FirebaseAuthProvider>,
	document.getElementById("root")
);
